import PropTypes from "prop-types"
import styled from "@emotion/styled"
import * as Icons from "../Icons"

const HeroBackgroundImage = ({ backgroundImage, colorVariant }) => {
  const IconComponent = Icons[backgroundImage]

  const Component = styled.div`
    > svg {
      ${colorVariant === "Dark" && "opacity: 0.05;"}
    }
  `
  return (
    <Component>
      <IconComponent />
    </Component>
  )
}

HeroBackgroundImage.propTypes = {
  backgroundImage: PropTypes.string.isRequired,
  colorVariant: PropTypes.string,
}

HeroBackgroundImage.defaultProps = {
  colorVariant: "Light",
}

export default HeroBackgroundImage
